module.exports = __webpack_public_path__ + "static/media/Icon Viewing.e782419b.svg";